<script lang="ts" setup>
import type { BreadcrumbWrapperProps } from '.';

import { cn } from '@/utils';

const props = defineProps<BreadcrumbWrapperProps>();
</script>

<template>
	<nav
		aria-label="PilarHomes, navegação"
		:class="cn('text-sm font-normal leading-[150%] text-primary', props.class)"
	>
		<slot />
	</nav>
</template>
